import {Component, OnInit, Input, ChangeDetectorRef, HostListener, OnDestroy} from '@angular/core';
import { KANBAN_TYPE_TASK, KanbanModel } from '../kanban.model';
import { Subject } from 'rxjs';
import { WorkflowComponentsService } from '../../workflow-components.service';
import { takeUntil } from 'rxjs/operators';
import { Model_WorkflowComponent } from 'src/app/app.models';
import { MatDialog } from '@angular/material/dialog';
import { MdKanbanFormAddTaskDialogComponent } from '../kanban-form/@modals/md-kanban-form-add-task-dialog/md-kanban-form-add-task-dialog.component';
import {v4 as uuidv4} from 'uuid';
import { FormBuilder } from '@angular/forms';
import * as moment from 'moment';
import { CdkDragDrop, moveItemInArray, transferArrayItem } from '@angular/cdk/drag-drop';

@Component({
    selector: 'abw-kanban-design',
    templateUrl: './kanban-design.component.html',
    styleUrls: ['./kanban-design.component.scss']
})
export class KanbanDesignComponent implements OnInit, OnDestroy {
    isComponentSelected = false;
    @Input() model: KanbanModel;
    @Input() value: any;
    onComplete = new Subject();

    constructor(
        private _workflowComponentsService: WorkflowComponentsService,
        private _cdf: ChangeDetectorRef,
    ) {
    }

    ngOnInit() {
        this._workflowComponentsService.workflowDesignerComponentSelected$.pipe(takeUntil(this.onComplete)).subscribe(_selectedComponent => {
            this.isComponentSelected = _selectedComponent != null && _selectedComponent.GUID == this.model.additional.GUID;
            this._cdf.detectChanges();
        });
    }

    @HostListener("click") onClick(){
        const base_component = this.model.additional as Model_WorkflowComponent;
        base_component.PROPERTIES = this.value;
        this._workflowComponentsService.workflowDesignerComponentSelected$.next(base_component);
    }

    ngOnDestroy() {
        this.onComplete.next();
        this.onComplete.complete();
    }
}